// import React from 'react';
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import {
  Box,
  // Grid,
  // Typography,
  // LinearProgress,
  Button,
} from "@material-ui/core";
import CircularProgress from "@mui/material/CircularProgress";
import { green } from "@mui/material/colors";

const ConfirmDialog = (props: any) => {
  const { title, children, open, setOpen, onConfirm, loading } = props;
  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="confirm-dialog"
    >
      <DialogTitle id="confirm-dialog">{title}</DialogTitle>
      <DialogContent>{children}</DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          onClick={() => setOpen(false)}
          color="default"
        >
          いいえ
        </Button>

        {/* <Button
          variant="contained"
          onClick={() => {
            // setOpen(false);
            onConfirm();
          }}
          color="secondary"
        >
          はい
        </Button> */}

        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Box sx={{ m: 1, position: "relative" }}>
            {loading ? (
              <Button
                style={{ width: "100px" }}
                variant="contained"
                disabled={loading}
                onClick={() => {
                  onConfirm();
                }}
                color="secondary"
              >
                はい
              </Button>
            ) : (
              <Button
                style={{
                  color: "#fff",
                  backgroundColor: "red",
                  width: "100px",
                }}
                disabled={loading}
                onClick={() => {
                  onConfirm();
                }}
                color="secondary"
              >
                はい
              </Button>
            )}
            {loading && (
              <CircularProgress
                size={24}
                sx={{
                  color: green[500],
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  marginTop: "-12px",
                  marginLeft: "-12px",
                }}
              />
            )}
          </Box>
        </Box>
      </DialogActions>
    </Dialog>
  );
};
export default ConfirmDialog;
